export { default } from './SchoolStats'
